import React from 'react';
import { Button } from 'react-bootstrap';
import { medicalCertificateService, documentService } from '../../services/api';

const FileViewer = ({ certificate, document, onDeleteFile, type }) => {
  // Supporta sia certificate che document come props per retrocompatibilità
  const entity = certificate || document;
  const entityType = type || (certificate ? 'certificate' : 'document');
  
  const hasFile = entity?.fileName && entity?.filePath;

  const handleDownload = async () => {
    try {
      let result;
      
      if (entityType === 'certificate') {
        result = await medicalCertificateService.downloadCertificateFile(entity);
      } else if (entityType === 'document') {
        result = await documentService.downloadDocumentFile(entity);
      } else {
        console.error('Entity type non riconosciuto per download:', entityType);
        alert('Tipo di entità non riconosciuto');
        return;
      }

      if (!result.success) {
        alert(result.message || 'Errore durante il download del file');
      }
    } catch (error) {
      console.error('Errore nel download:', error);
      alert('Errore di connessione durante il download');
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Sei sicuro di voler eliminare questo file?')) {
      return;
    }

    try {
      let result;
      
      if (entityType === 'certificate') {
        result = await medicalCertificateService.deleteFileCertificate(entity.id);
      } else if (entityType === 'document') {
        result = await documentService.deleteFileDocument(entity.id);
      } else {
        console.error('Entity type non riconosciuto:', entityType);
        alert('Tipo di entità non riconosciuto');
        return;
      }

      if (result && result.success) {
        onDeleteFile?.();
      } else {
        console.error('Delete failed:', result);
        alert(result?.message || 'Errore durante l\'eliminazione del file');
      }
    } catch (error) {
      console.error('Delete error:', error);
      alert('Errore di connessione durante l\'eliminazione');
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '';
    const mb = bytes / 1024 / 1024;
    return `(${mb.toFixed(2)} MB)`;
  };

  const getFileIcon = (fileName) => {
    if (!fileName) return 'fas fa-file';
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'fas fa-file-pdf text-danger';
      case 'jpg':
      case 'jpeg':
      case 'png':
        return 'fas fa-file-image text-primary';
      default:
        return 'fas fa-file';
    }
  };

  if (!hasFile) {
    return (
      <div className="text-muted">
        <i className="fas fa-times-circle me-2"></i>
        Nessun documento allegato
      </div>
    );
  }

  return (
    <div className="file-viewer">
      <div className="d-flex align-items-center">
        <i className={`${getFileIcon(entity.fileName)} me-2`}></i>
        <div>
          <div className="fw-medium">
            {entity.fileName}
            {entity.fileSize && (
              <small className="text-muted ms-2">
                {formatFileSize(entity.fileSize)}
              </small>
            )}
          </div>
          <div className="mt-1">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={handleDownload}
              className="me-2"
              style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
            >
              <i className="fas fa-download me-1"></i>
              Scarica
            </Button>
            <Button
              variant="outline-danger"
              size="sm"
              onClick={handleDelete}
              style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
            >
              <i className="fas fa-trash me-1"></i>
              Elimina
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileViewer;
